var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{attrs:{"type":"is-light","disabled":_vm.loading || _vm.liveVehicles.length === 0},on:{"click":_vm.exportCsv}},[_c('b-icon',{attrs:{"icon":"file-export","size":"is-small"}}),_vm._v(" "),_c('span',[_vm._v("Export CSV")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }